import { IconPointFilled } from '@tabler/icons-react';
import { Outlet, createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { isTravelAdminRole } from '@/module/Travel/travelRoles';
import { isLocalAccountAdminRole } from '@/module/User/userRoles';
import { isUserDocumentAdminRole } from '@/module/UserDocument/userDocumentRoles';

import { ContextSidebar } from '@/core/components/RootLayout/Sidebar/ContextSidebar';

import { RoleType, useRoleBoundary } from '@feature/security';

export const Route = createFileRoute('/_auth/administration/_administration')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.administration' },
  },
});

function RouteComponent() {
  const { t } = useTranslation();
  const { isRole, roleType } = useRoleBoundary();

  // The organisation tabs keep their audience; ADMIN only gets the legal holidays.
  const organisationTabsVisible = !isRole(RoleType.ADMIN);

  const tabs = [
    { label: t('sidebar.disciplines'), to: 'discipline', icon: IconPointFilled, visible: organisationTabsVisible },
    { label: t('sidebar.departments'), to: 'department', icon: IconPointFilled, visible: organisationTabsVisible },
    { label: t('sidebar.faculties'), to: 'faculty', icon: IconPointFilled, visible: organisationTabsVisible },
    {
      label: t('sidebar.legalHolidays'),
      to: 'legal-holiday',
      icon: IconPointFilled,
      visible: isTravelAdminRole(roleType),
    },
    {
      label: t('sidebar.universityConfig'),
      to: 'university-config',
      icon: IconPointFilled,
      visible: isTravelAdminRole(roleType),
    },
    {
      label: t('sidebar.userDocuments'),
      to: 'user-documents',
      icon: IconPointFilled,
      visible: isUserDocumentAdminRole(roleType),
    },
    {
      label: t('sidebar.localAccounts'),
      to: 'local-accounts',
      icon: IconPointFilled,
      visible: isLocalAccountAdminRole(roleType),
    },
  ];

  return (
    <>
      <ContextSidebar
        baseUrl="administration"
        items={tabs.filter(tab => tab.visible)}
      />
      <Outlet />
    </>
  );
}
